import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as type from '../ActionTypes';
import { getCoderProfileService } from '../../services/profile/coder.service';
import { fetchCodersListFailure, fetchCodersListSuccess } from '../actions/coders';
import { BaseApiResponseWithPagination, CoderProfile } from '../../types/shared.types';

function* getCoderList({ params }: any): any {
  try {
    const coders: BaseApiResponseWithPagination<CoderProfile> = yield call(
      getCoderProfileService,
      params
    );
    yield put(fetchCodersListSuccess(coders));
  } catch (e: any) {
    yield put(fetchCodersListFailure(e.message || 'Oops! Something went wrong'));
    console.warn(e.message);
  }
}

function* cordersSaga() {
  yield takeLatest(type.GET_CODERS_LIST, getCoderList);
}

export default cordersSaga;
